export default class RouterConfig {
    static LOGIN = "/login"
	static CHANGE_PASSWORD = "/change-password";
}